import styled from "styled-components";

export const Wrapper = styled.div`
  --bg: #f1f2f4;
  --surface: #ffffff;
  --surface2: #f1f2f4;
  --border: #d5dce8;
  --border2: #d9dce0;
  --coral: #f45b68;
  --coral-d: #d94855;
  --coral-glow: rgba(244, 91, 104, 0.14);
  --navy: #314f71;
  --navy-glow: rgba(49, 79, 113, 0.12);
  --green: #22c55e;
  --text: #111827;
  --text-soft: #313740;
  --text-muted: #6b7280;
  --white: #ffffff;

  background: var(--surface);
  color: var(--text);
  height: calc(100vh - -50px);
  overflow: hidden;
  border-radius: 14px;
  font-family: "Inter", sans-serif;
  border: 1px solid var(--border);

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    height: 65px;
    background: #ffffff;
    border-bottom: 1px solid var(--border);
    position: relative;
  }

  header::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, var(--coral), var(--navy), transparent);
    opacity: 0.6;
  }

  .logo-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
  }
.logo-square {
    border-right: 1px solid #ddd;
    padding-right: 10px;
}
  .logo-square img{
    width: 30px;
  }

  .logo-text {
    font-family: "Inter", sans-serif;
    font-size: 17px;
    font-weight: 700;
    letter-spacing: -0.4px;
    color: var(--navy);
  }

  .logo-text span {
    color: var(--coral);
  }

  .hdr-right {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .badge {
    font-family: "Inter", sans-serif;
    font-size: 10px;
    font-weight: 600;
    background: var(--coral-glow);
    color: var(--coral);
    border: 1px solid rgba(244, 91, 104, 0.28);
    padding: 3px 9px;
    border-radius: 20px;
    letter-spacing: 0.4px;
  }

  .status {
    display: flex;
    align-items: center;
    gap: 6px;
    background: rgba(34, 197, 94, 0.1);
    border: 1px solid rgba(34, 197, 94, 0.22);
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 11.5px;
    font-weight: 500;
    color: var(--green);
  }

  .dot {
    width: 6px;
    height: 6px;
    background: var(--green);
    border-radius: 50%;
    animation: pulse 2s infinite;
  }

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.35;
    }
  }

  .chat-wrap {
    display: flex;
    height: calc(100% - 62px);
    overflow: hidden;
  }

  .sidebar {
    width: 275px;
    background: #f1f2f4;
    border-right: 1px dashed var(--border);
    display: flex;
    flex-direction: column;
    padding: 16px 12px;
    gap: 3px;
    overflow-y: auto;
    flex-shrink: 0;
  }

  .sidebar::-webkit-scrollbar,
  .messages::-webkit-scrollbar {
    width: 3px;
  }

  .sidebar::-webkit-scrollbar-thumb,
  .messages::-webkit-scrollbar-thumb {
    background: var(--border2);
    border-radius: 4px;
  }

  .s-label {
    font-family: "Inter", sans-serif;
    font-size: 9.7px;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: #1d1d1d;
    font-weight: 600;
    padding: 0 8px;
    margin: 14px 0 5px;
  }

  .s-label:first-child {
    margin-top: 0;
  }

  .qq {
    background: var(--surface2);
    border: 1px solid var(--surface2);
    border-radius: 9px;
    padding: 9px 12px;
    font-size: 13px;
    font-weight: 500;
    color: var(--text-soft);
    line-height: 1.4;
    text-align: left;
    width: 100%;
    display: flex;
    gap: 8px;
    align-items: flex-start;
    cursor: pointer;
    transition: all 0.18s;
  }

  .qq:hover {
    background: var(--coral-glow);
    border-color: var(--surface2);
    color: var(--coral);
    transform: translateX(3px);
  }

  .qq.nv:hover {
    background: var(--coral-glow);
    border-color: var(--surface2);
    color: var(--coral);
  }

  .s-divider {
    height: 1px;
    background: linear-gradient(90deg, transparent, var(--border2), transparent);
    margin: 8px 0;
  }

  .chat-main {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: var(--bg);
  }

  .messages {
    flex: 1;
    overflow-y: auto;
    padding: 32px 36px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .welcome {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 50px 24px 24px;
    animation: rise 0.5s ease both;
  }

  .w-icon {
  width: 85px;
  height: 85px;
  border: 1px solid var(--border2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;

  background: linear-gradient(
    270deg,
    #f45b68,
    #b62733,
    #ff7a59,
    #f45b68
  );

  background-size: 600% 600%;

  box-shadow: 0 8px 20px rgba(49, 79, 113, 0.1);

  animation:
    floaty 2.5s ease-in-out infinite,
    gradientMove 6s ease infinite;
}

/* Floating animation */
@keyframes floaty {
  0% {
    transform: translateY(0);
    box-shadow: 0 8px 20px #f45b6873 ;
  }

  50% {
    transform: translateY(-8px);
    box-shadow: 0 24px 30px #f45b6873 ;
  }

  100% {
    transform: translateY(0);
    box-shadow: 0 8px 20px #f45b6873;
  }
}

/* Gradient color animation */
@keyframes gradientMove {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

  .bot-mark {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "Inter", sans-serif;
    font-weight: 700;
    letter-spacing: 0.8px;
    color: var(--white);
  }

  .welcome h2 {
    font-family: "Inter", sans-serif;
    font-size: 25px;
    font-weight: 600;
    color: var(--navy);
    margin-bottom: 10px;
    letter-spacing: -0.4px;
  }

  .welcome h2 span {
    color: var(--coral);
  }

  .welcome p {
    font-size: 14px;
    color: var(--text-muted);
    max-width: 420px;
    line-height: 1.7;
  }

  .chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
    margin-top: 20px;
    max-width: 520px;
  }

  .chip {
    background: #fff;
    border: 1px solid var(--border2);
    border-radius: 20px;
    padding: 6px 16px;
    font-size: 12.5px;
    color: var(--text-soft);
    cursor: pointer;
    transition: all 0.18s;
  }

  .chip:hover {
    border-color: var(--coral);
    background: var(--coral-glow);
    color: var(--coral);
  }

  .row {
    display: flex;
    gap: 10px;
    align-items: flex-start;
    animation: rise 0.3s ease both;
  }

  .row.user {
    flex-direction: row-reverse;
  }

  @keyframes rise {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

 

  .av {
    width: 37px;
    height: 37px;
    border-radius: 50px;
    display: flex;
    // align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 2px;
    overflow: hidden;
  }

  .av.bot {
    background: linear-gradient(135deg, #314f71, #44688f);
    border: 1px solid #dce6f2;
    box-shadow: 0 4px 10px rgba(49, 79, 113, 0.12);
  }

  .av.user {
    background: linear-gradient(135deg, #fff1f2, #ffecee);
    color: var(--coral);
    font-family: "Inter", sans-serif;
    font-size: 12px;
    font-weight: 700;
    border: 1px solid rgba(77, 142, 247, 0.25);
  }

  .bubble {
    max-width: 65%;
    padding: 13px 16px;
    border-radius: 14px;
    font-size: 14px;
    line-height: 1.7;
  }

  .bubble.bot {
    background: #ffffff;
    // border: 1px solid var(--border);
    border-top-left-radius: 4px;
    color: var(--text);
    box-shadow: 0 6px 16px rgba(17, 24, 39, 0.05);
  }

  .bubble.user {
    background: linear-gradient(135deg, #314f71, #45698f);
    border: 1px solid rgba(49, 79, 113, 0.24);
    border-top-right-radius: 4px;
    color: var(--white);
    box-shadow: 0 6px 16px rgba(49, 79, 113, 0.18);
  }

  .mgrid {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    margin-top: 12px;
  }

  .mc {
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: 10px;
    padding: 11px 14px;
    min-width: 108px;
    flex: 1;
    // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  }

  .ml {
    font-size: 10.5px;
    color: var(--text-muted);
    font-weight: 500;
    margin-bottom: 4px;
    letter-spacing: 0.3px;
  }

  .mv {
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 700;
  }

  .mv.co {
    color: var(--coral);
  }

  .mv.nv {
    color: var(--navy);
  }

  .mv.gr {
    color: var(--green);
  }

  .mch {
    font-size: 11px;
    margin-top: 2px;
    font-weight: 500;
  }

  .mch.dn {
    color: var(--coral);
  }

  .typ {
    display: flex;
    gap: 5px;
    align-items: center;
    padding: 3px 0;
  }

  .typ span {
    width: 7px;
    height: 7px;
    background: var(--border2);
    border-radius: 50%;
    animation: bounce 1.2s infinite;
  }

  .typ span:nth-child(2) {
    animation-delay: 0.18s;
  }

  .typ span:nth-child(3) {
    animation-delay: 0.36s;
  }

  @keyframes bounce {
    0%,
    80%,
    100% {
      transform: translateY(0);
      background: var(--border2);
    }
    40% {
      transform: translateY(-6px);
      background: var(--coral);
    }
  }

  .input-bar {
    padding: 14px 24px 18px;
    background: var(--surface2);
    // border-top: 1px solid var(--border);
    flex-shrink: 0;
  }

  .irow {
    display: flex;
    align-items: center;
    gap: 10px;
    background: #fff;
    border: 1.5px solid #ffd1d5;
    border-radius: 14px;
    padding: 15px 15px 15px 15px;
    transition: border-color 0.2s, box-shadow 0.2s;
    max-width: 80%;
    margin-left: auto;
    margin-right: auto;
  }

  .irow:focus-within {
    border-color: rgba(244, 91, 104, 0.5);
  }

  textarea {
    flex: 1;
    background: transparent;
    border: none;
    outline: none;
    color: var(--text);
    font-size: 14px;
    resize: none;
    max-height: 110px;
    min-height: 22px;
    line-height: 1.5;
    font-family: inherit;
  }

  textarea::placeholder {
    color: var(--text-muted);
  }

  .sbtn {
    width: 40px;
    height: 40px;
    background: linear-gradient(135deg, var(--coral), var(--coral-d));
    border: none;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
    transition: all 0.18s;
    box-shadow: 0 8px 18px rgba(244, 91, 104, 0.25);
  }

  .sbtn:hover:not(:disabled) {
    transform: scale(1.06);
    box-shadow: 0 10px 22px rgba(244, 91, 104, 0.32);
  }

  .sbtn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .sbtn svg {
    width: 20px;
    height: 20px;
    fill: white;
  }

  .hint {
    text-align: center;
    font-size: 11px;
    color: var(--text-muted);
    margin-top: 8px;
  }

  .hint strong {
    color: var(--text-soft);
    font-weight: 500;
  }

  @media (max-width: 991px) {
    .sidebar {
      display: none;
    }

    .messages {
      padding: 18px 14px;
    }

    .bubble {
      max-width: 90%;
    }
  }
`;